import type { IFetcher } from "../../util/io/Fetcher";
import { AddNewPairingResponse } from "../responses/AddNewPairingResponse";
import { GetPairingsByBrowserKeyResponse } from "../responses/GetPairingsByBrowserKeyResponse";
import { ITblHomerPairing } from "../../app/viewer/network/contracts/db/maindb/tblHomerPairing";
import { RemovePairingResponse } from "../responses/RemovePairingResponse";
import { GetAppVersionInfoResponse } from "../responses/GetAppVersionInfoResponse";
import { GetPossibleLanguagesResponse } from "../responses/GetPossibleLanguagesResponse";

export interface IHomeReadingFetcher {
	getPairingsByBrowserKey(browserKey: string): Promise<GetPairingsByBrowserKeyResponse>;

	addNewPairing(pairing: any): Promise<AddNewPairingResponse>;

	removePairing(pairing: ITblHomerPairing, browserKey: string): Promise<RemovePairingResponse>;

	getAppVersionInfo(): Promise<GetAppVersionInfoResponse>;

	getPossibleLanguages(): Promise<GetPossibleLanguagesResponse>;
}

export class HomeReadingFetcher implements IHomeReadingFetcher {
	constructor(private readonly fetcher: IFetcher) {}

	async getPairingsByBrowserKey(browserKey: string): Promise<GetPairingsByBrowserKeyResponse> {
		const { fetcher } = this;
		const url = "/POW3/Homer/GetPairingsByBrowserKey?browserKey=" + browserKey;
		return await fetcher.getJSON<GetPairingsByBrowserKeyResponse>(url);
	}

	async addNewPairing(pairing: ITblHomerPairing): Promise<AddNewPairingResponse> {
		const { fetcher } = this;

		const requestParams = {
			homerPairing: pairing,
		};

		const url = "/POW3/Homer/AddNewPairing";
		return await fetcher.postJSON<AddNewPairingResponse>(url, requestParams);
	}
	async removePairing(pairing: ITblHomerPairing, browserKey: string): Promise<RemovePairingResponse> {
		const { fetcher } = this;

		const requestParams = {
			browserKey: browserKey,
			pGuid: pairing.pGuid,
			pairCode: pairing.pairCode,
		};

		const url = "/POW3/Homer/RemovePairing";
		return await fetcher.postJSON<RemovePairingResponse>(url, requestParams);
	}

	async getAppVersionInfo(): Promise<GetAppVersionInfoResponse> {
		const { fetcher } = this;
		const url = "/POW3/Homer/GetAppVersionInfo";
		return await fetcher.getJSON<GetAppVersionInfoResponse>(url);
	}

	async getPossibleLanguages(): Promise<GetPossibleLanguagesResponse> {
		const { fetcher } = this;
		const url = "/POW3/Homer/GetPossibleLanguages";
		return await fetcher.getJSON<GetPossibleLanguagesResponse>(url);
	}
}
